/**
 * SLIDERS
 */
export function initSwiper() {
  const heroSlider = document.querySelector(".hero-home__slider");

  if (heroSlider) {
    const slides = heroSlider.querySelectorAll(".swiper-slide");

    new Swiper(heroSlider, {
      slidesPerView: 1,
      spaceBetween: 0,

      loop: slides.length > 1,

      speed: 1200,

      effect: "fade",

      fadeEffect: {
        crossFade: true,
      },

      autoplay:
        slides.length > 1
          ? {
              delay: 5000,
              disableOnInteraction: false,
            }
          : false,

      navigation: {
        nextEl: heroSlider.querySelector(".swiper-button-next"),
        prevEl: heroSlider.querySelector(".swiper-button-prev"),
      },
    });
  }

  const quienesSliders = document.querySelectorAll(
    "#quienes-intro .quienes-swiper",
  );
  quienesSliders.forEach((slider, index) => {
    const container = slider.closest(".quienes-slider-container");
    const pagination = container.querySelector(".swiper-pagination");
    const totalSlides = slider.querySelectorAll(".swiper-slide").length;
    const swiper = new Swiper(slider, {
      slidesPerView: 1,
      spaceBetween: 0,
      speed: 700,
      loop: totalSlides > 1,
      grabCursor: totalSlides > 1,
      allowTouchMove: totalSlides > 1,
      effect: "fade",
      fadeEffect: {
        crossFade: true,
      },
      pagination: pagination
        ? {
            el: pagination,
            clickable: true,
          }
        : false,
      autoplay:
        totalSlides > 1
          ? {
              delay: 5000,
              disableOnInteraction: false,
            }
          : false,
    });
    if (index === 1 && totalSlides > 1) {
      swiper.autoplay.stop();
      setTimeout(() => {
        swiper.autoplay.start();
      }, 500);
    }
  });

  function initEmpanadasSwiper() {
    document.querySelectorAll(".empanada-swiper").forEach((slider) => {
      const galeria = slider.closest(".empanada-galeria");
      const totalSlides = slider.querySelectorAll(".swiper-slide").length;
      const next = galeria.querySelector(".empanada-next");
      const prev = galeria.querySelector(".empanada-prev");

      const swiper = new Swiper(slider, {
        slidesPerView: 1,
        speed: 700,
        spaceBetween: 5,
        grabCursor: true,
        loop: totalSlides > 1,
        navigation: {
          nextEl: next,
          prevEl: prev,
        },
        autoplay: false,
      });

      if (totalSlides > 1) {
        galeria.addEventListener("mouseenter", (e) => {
          if (e.target.closest(".empanada-next, .empanada-prev")) return;
          swiper.slideToLoop(1);
        });

        galeria.addEventListener("mouseleave", () => {
          swiper.slideToLoop(0);
        });

        next?.addEventListener("mouseenter", () => swiper.slideNext());
        prev?.addEventListener("mouseenter", () => swiper.slidePrev());
      }
    });
  }

  initEmpanadasSwiper();

  function initRelatedProducts() {
    document.querySelectorAll(".relacionados-swiper").forEach((slider) => {
      if (slider.swiper) return;

      const section = slider.closest("#productos-relacionados");
      const totalSlides = slider.querySelectorAll(".swiper-slide").length;

      new Swiper(slider, {
        slidesPerView: 1,
        spaceBetween: 16,
        grabCursor: true,
        watchOverflow: true,
        navigation: {
          nextEl: section.querySelector(".relacionados-next"),
          prevEl: section.querySelector(".relacionados-prev"),
        },
        loop: totalSlides > 1,
        speed: 700,
        autoplay:
          totalSlides > 1
            ? {
                delay: 5000,
                disableOnInteraction: false,
              }
            : false,

        breakpoints: {
          640: {
            slidesPerView: 2,
            spaceBetween: 20,
          },
          1024: {
            slidesPerView: 3,
            spaceBetween: 24,
          },
        },
      });
    });
  }

  initRelatedProducts();

  document.querySelectorAll(".locales-zona:not(.single)").forEach((zona) => {
    const swiperEl = zona.querySelector(".locales-swiper");
    const prevEl = zona.querySelector(".locales-prev");
    const nextEl = zona.querySelector(".locales-next");
    const totalSlides = swiperEl.querySelectorAll(".swiper-slide").length;

    new Swiper(swiperEl, {
      slidesPerView: 1,
      spaceBetween: 10,
      navigation: {
        prevEl,
        nextEl,
      },
      grabCursor: true,
      watchOverflow: true,
      loop: totalSlides > 1,
      speed: 700,
      autoplay:
        totalSlides > 1
          ? {
              delay: 10000,
              disableOnInteraction: false,
            }
          : false,
      breakpoints: {
        640: {
          slidesPerView: 2,
          spaceBetween: 16,
        },
        1024: {
          slidesPerView: 3,
          spaceBetween: 18,
        },
        1400: {
          slidesPerView: 3,
          spaceBetween: 20,
        },
      },
    });
  });
}
